import { FilterItem } from "../../../../../../../dashboard/reports/components/table/utils/styled";
import FormControl from "@mui/material/FormControl";
import { InputLabel, NativeSelect } from "../../../../../../../../common/styles/muiStyled";
import { FilterProps } from "../../../../../../types";
import startCase from "lodash.startcase";
import { SelectChangeEvent } from "@mui/material/Select";
import { useTranslation } from "react-i18next";

type Props = Omit<FilterProps, "config" | 'filterTableData'>;

export const CustomerTypeFilter = ({ filterSetters, filterGetters }: Props) => {
  const { t } = useTranslation('common');

  const onChange = (e: SelectChangeEvent) => {
    filterSetters.onCustomerTypeFilterChange(e.target.value);
  };

  return (
    <FilterItem>
      <FormControl fullWidth>
        <InputLabel>{t('companyPage.customerType')}</InputLabel>
        <NativeSelect value={filterGetters.selectedCustomerType} onChange={onChange}>
          {filterGetters.customerTypeOptions.map(({ type, label }) => (
            <option key={type} value={type}>
              {startCase(label)}
            </option>
          ))}
        </NativeSelect>
      </FormControl>
    </FilterItem>
  );
};
